import { isly } from "isly";
import { Date } from "../Date";
import { system } from "../system";
export var DateRange;
(function (DateRange) {
    var _a;
    _a = isly
        .object({ start: Date.type, end: Date.type }, "isoly.DateRange")
        .bind(), DateRange.type = _a.type, DateRange.is = _a.is, DateRange.flawed = _a.flawed;
    function create(start, end) {
        return !Date.is(end)
            ? create(start, Date.next(start, end))
            : start <= end
                ? { start, end }
                : { start: end, end: start };
    }
    DateRange.create = create;
    function toDates(value, includeLast = true) {
        const result = [];
        for (let current = value.start; includeLast ? current <= value.end : current < value.end; current = Date.next(current))
            result.push(current);
        return result;
    }
    DateRange.toDates = toDates;
    function getDays(value) {
        const result = value.start <= value.end
            ? Math.ceil((new system.Date(value.end).getTime() - new system.Date(value.start).getTime()) / (1000 * 3600 * 24))
            : -getDays({ start: value.end, end: value.start });
        return result;
    }
    DateRange.getDays = getDays;
})(DateRange || (DateRange = {}));
//# sourceMappingURL=index.js.map